var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 270.659,
  height: 244.334
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 28814"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23937"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23316",
  d: "M163.185 204.396a86.018 86.018 0 1 1 86.018-86.019 86.116 86.116 0 0 1-86.018 86.019Zm0-170.563a84.545 84.545 0 1 0 84.545 84.545 84.641 84.641 0 0 0-84.545-84.545Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23938"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23317",
  d: "M82.342 176.211a2.783 2.783 0 0 1-2.766-2.547l-.982-11.6a2.784 2.784 0 0 1 2.536-3.006l6.952-.589a2.786 2.786 0 0 1 3.006 2.537l.982 11.6a2.78 2.78 0 0 1-2.537 3.006l-6.952.589c-.079.007-.159.01-.239.01Zm5.975-16.281h-.11l-6.952.589a1.31 1.31 0 0 0-1.193 1.414l.982 11.6a1.309 1.309 0 0 0 1.414 1.194l6.952-.589a1.307 1.307 0 0 0 1.193-1.414l-.982-11.6a1.311 1.311 0 0 0-1.304-1.193Z",
  fill: "#ffa901"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23941"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23320",
  d: "m132.24 40.379-4.316 15.707-10.8-12.19 4.316-15.706Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23321",
  d: "M127.925 56.823a.738.738 0 0 1-.551-.248l-10.8-12.191a.735.735 0 0 1-.159-.684l4.315-15.706a.736.736 0 0 1 1.262-.293l10.8 12.19a.736.736 0 0 1 .159.684l-4.316 15.707a.736.736 0 0 1-.543.522.728.728 0 0 1-.167.019Zm-9.987-13.117 9.637 10.875 3.85-14.01-9.638-10.872Z",
  fill: "#ffa901"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23942"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 6708",
  width: 137.564,
  height: 242.861,
  rx: 25.506,
  transform: "translate(.737 .736)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23322",
  d: "M123.272 244.338H15.765A15.783 15.783 0 0 1 0 228.573v-212.8A15.783 15.783 0 0 1 15.765.008h107.507a15.783 15.783 0 0 1 15.761 15.757v212.8a15.783 15.783 0 0 1-15.761 15.773ZM15.765 1.473A14.308 14.308 0 0 0 1.473 15.765v212.8a14.308 14.308 0 0 0 14.292 14.292h107.507a14.308 14.308 0 0 0 14.292-14.292v-212.8a14.308 14.308 0 0 0-14.292-14.292Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23943",
  transform: "translate(12.078 28.218)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 6709",
  width: 114.264,
  height: 171.037,
  rx: 5,
  transform: "translate(.442 .442)",
  fill: "#0f5aec"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23323",
  d: "M110.234 171.92H4.914A4.919 4.919 0 0 1 0 167.006V4.914A4.919 4.919 0 0 1 4.914 0h105.32a4.92 4.92 0 0 1 4.915 4.914v162.092a4.92 4.92 0 0 1-4.915 4.914ZM4.914.884a4.034 4.034 0 0 0-4.03 4.03v162.092a4.034 4.034 0 0 0 4.03 4.03h105.32a4.035 4.035 0 0 0 4.031-4.03V4.914a4.035 4.035 0 0 0-4.031-4.03Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23944",
  transform: "translate(58.434 210.706)",
  fill: "#0f5aec"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1797",
  cx: 10.643,
  cy: 10.643,
  r: 10.643,
  transform: "translate(.441 .442)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23324",
  d: "M11.084 22.169a11.085 11.085 0 1 1 11.085-11.085 11.1 11.1 0 0 1-11.085 11.085Zm0-21.285a10.2 10.2 0 1 0 10.2 10.2 10.212 10.212 0 0 0-10.2-10.2Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23982"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23961"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23946"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 286",
  fill: "#fff",
  d: "m108.263 116.176 12.325 68.211"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23326",
  d: "M120.587 185.123a.737.737 0 0 1-.724-.606l-12.325-68.211a.737.737 0 0 1 1.45-.263l12.325 68.216a.737.737 0 0 1-.593.856.725.725 0 0 1-.133.008Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23947"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23327",
  d: "M129.609 163.418a19.38 19.38 0 1 1-19.066 22.874l-7.461-25.714v-13.434",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23328",
  d: "M129.609 202.913a20.1 20.1 0 0 1-19.783-16.453l-7.45-25.677a.734.734 0 0 1-.029-.206v-13.434a.737.737 0 0 1 1.473 0v13.326l7.431 25.613a.887.887 0 0 1 .018.074 18.645 18.645 0 1 0 18.341-22.005.737.737 0 0 1 0-1.473 20.116 20.116 0 0 1 0 40.232Z",
  fill: "#005b9e"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23948"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23329",
  d: "m148.497 187.136 7.114-52.372s20.408 3.734 22.371-4.436-14.129-8.706-14.129-8.706a5.107 5.107 0 0 0-4.28-6.67l-7.983-.9a11.7 11.7 0 0 0-12.786 9.335l-8.356 41.477-5.2-23.015-25.123-2.809.668 9.98",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23330",
  d: "M148.499 187.873a.709.709 0 0 1-.1-.007.736.736 0 0 1-.63-.828l7.114-52.372a.737.737 0 0 1 .862-.626c5.487 1 20.047 2.259 21.522-3.884a3.976 3.976 0 0 0-.667-3.535c-2.96-3.888-12.672-4.259-12.77-4.262a.736.736 0 0 1-.675-.966 4.37 4.37 0 0 0-3.663-5.708l-7.982-.9a10.9 10.9 0 0 0-11.982 8.747l-8.356 41.478a.736.736 0 0 1-.714.591h-.009a.736.736 0 0 1-.718-.574l-5.08-22.5-23.726-2.654.609 9.1a.737.737 0 0 1-1.47.1l-.668-9.98a.735.735 0 0 1 .817-.781l25.122 2.809a.738.738 0 0 1 .637.57l4.436 19.651 7.674-38.1a12.364 12.364 0 0 1 13.591-9.921l7.983.9a5.845 5.845 0 0 1 5.119 6.717c2.619.194 10.159 1.066 12.995 4.789a5.437 5.437 0 0 1 .929 4.773c-1.9 7.9-18.611 5.726-22.46 5.117l-7.012 51.618a.736.736 0 0 1-.728.638Z",
  fill: "#005b9e"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23949",
  fill: "#759eed"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23331",
  d: "m104.579 199.526-68-.084.461-54.363-24.5-.228.233-7.819q.013-.717.04-1.42v-14.374a26.764 26.764 0 0 1 26.732-26.813l54.313.013c11.7 0 19.274 6.726 24.261 16.647a50.755 50.755 0 0 1 4.454 13.515l4.224 22.726-22.231-.005Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23332",
  d: "m104.58 200.262-68-.084a.736.736 0 0 1-.735-.742l.455-53.628-23.768-.221a.737.737 0 0 1-.729-.758l.233-7.819c.008-.474.022-.953.04-1.426v-14.346a27.5 27.5 0 0 1 27.462-27.55h.007l54.313.013c10.848 0 19.233 5.74 24.919 17.053a51.479 51.479 0 0 1 4.52 13.711l4.237 22.727a.737.737 0 0 1-.724.871l-21.494-.006.012 51.469a.735.735 0 0 1-.737.736Zm-67.261-1.556 66.525.082-.013-51.465a.737.737 0 0 1 .737-.737l21.344.006-4.074-21.855a50.052 50.052 0 0 0-4.389-13.319c-5.492-10.926-13.213-16.24-23.6-16.242l-54.313-.013h-.007A26.028 26.028 0 0 0 13.54 121.24v14.374c-.019.492-.031.96-.04 1.433l-.212 7.076 23.754.221a.737.737 0 0 1 .729.743Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23953"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23950"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23333",
  d: "M41.06 68.328a26.429 26.429 0 0 1 52.7-4.031 26.1 26.1 0 0 1-12.075 24.518l-.113 4.869s-3.212 9.9-10.562 10.465c-6.386.488-10.215-3.124-13.871-9.726l.064-3.734A26.42 26.42 0 0 1 41.06 68.328Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23334",
  d: "M69.916 104.93c-6.817 0-10.48-4.851-13.414-10.149a.745.745 0 0 1-.092-.369l.055-3.241a27.067 27.067 0 0 1-16.137-22.786 27.167 27.167 0 1 1 42.091 20.844l-.1 4.473a.747.747 0 0 1-.036.21c-.137.424-3.454 10.38-11.206 10.972q-.597.046-1.161.046ZM57.887 94.239c3.923 7.019 7.6 9.595 13.074 9.177 6.394-.489 9.533-8.862 9.885-9.862l.109-4.756a.737.737 0 0 1 .35-.609 25.823 25.823 0 0 0-15.849-47.493 25.721 25.721 0 0 0-23.659 27.576 25.606 25.606 0 0 0 15.7 21.739.735.735 0 0 1 .451.692Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23952"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23951"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23335",
  d: "m89.937 65.168-12.1 2.292a6.65 6.65 0 0 0 7.665 3.394 5.558 5.558 0 0 0 4.435-5.686Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23336",
  d: "M83.643 71.828a7.569 7.569 0 0 1-6.469-4.051.737.737 0 0 1 .528-1.041l12.1-2.292a.737.737 0 0 1 .872.671 6.257 6.257 0 0 1-4.991 6.454 8.455 8.455 0 0 1-2.04.259Zm-4.6-3.846a5.763 5.763 0 0 0 6.287 2.157 4.735 4.735 0 0 0 3.829-4.073Z",
  fill: "#0445a5"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23959"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23342",
  d: "M46.013 58.016a.734.734 0 0 1-.458-.16 5.8 5.8 0 0 0-6.282-.461.736.736 0 1 1-.727-1.28 7.27 7.27 0 0 1 7.928.59.737.737 0 0 1-.461 1.312Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23960"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23343",
  d: "M44.76 56.428a.73.73 0 0 1-.444-.149c-2.328-1.761-1.931-5.238-1.913-5.385a.737.737 0 0 1 1.462.178c0 .028-.307 2.786 1.339 4.033a.736.736 0 0 1-.444 1.324Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23963"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23345",
  d: "M51.489 67.099a.737.737 0 0 1-.468-1.306 20.643 20.643 0 0 0 7.652-17.853.736.736 0 0 1 1.456-.223 21.811 21.811 0 0 1-8.172 19.214.735.735 0 0 1-.468.168Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23964"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23346",
  d: "M49.441 75.164a5.332 5.332 0 0 1-1.487-10.45.737.737 0 0 1 .412 1.415 3.857 3.857 0 1 0 2.162 7.405.736.736 0 0 1 .412 1.414 5.348 5.348 0 0 1-1.499.216Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23965"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23347",
  d: "M60.078 45.68h-.087A.737.737 0 0 1 60 44.207h.03c.517 0 9.828-.082 15.082-5.375a.737.737 0 0 1 1.045 1.038c-5.604 5.643-15.006 5.81-16.079 5.81Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23966"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23348",
  d: "M64.905 75.662a24.141 24.141 0 0 1-15.955-5.8.737.737 0 0 1 1.036-1.048c.4.4 10.063 9.656 25.829 3.052a.737.737 0 0 1 .569 1.359 29.573 29.573 0 0 1-11.479 2.437Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23967",
  transform: "translate(74.001 70.355)",
  fill: "#0445a5"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1798",
  cx: 1.362,
  cy: 1.362,
  r: 1.362,
  transform: "translate(.736 .737)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23349",
  d: "M2.098 4.196a2.1 2.1 0 1 1 2.1-2.1 2.1 2.1 0 0 1-2.1 2.1Zm0-2.723a.625.625 0 1 0 .625.625.625.625 0 0 0-.625-.625Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23968"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23350",
  d: "M83.532 54.401a4.313 4.313 0 0 1-1.754-.372l-1.4-.622a.737.737 0 1 1 .6-1.346l1.4.622a2.859 2.859 0 0 0 3.4-.836l1.048-1.322a.737.737 0 1 1 1.154.915l-1.048 1.322a4.329 4.329 0 0 1-3.4 1.639Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23969"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23351",
  d: "M73.596 57.084a4.31 4.31 0 0 1-1.754-.372l-1.4-.622a.737.737 0 0 1 .6-1.347l1.4.623a2.856 2.856 0 0 0 3.4-.836l1.048-1.322a.736.736 0 0 1 1.154.915l-1.048 1.322a4.327 4.327 0 0 1-3.4 1.639Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23972"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 287",
  fill: "#fff",
  d: "m163.854 121.621-11.432-1.498"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23354",
  d: "M163.855 122.359a.654.654 0 0 1-.1-.007l-11.432-1.5a.737.737 0 0 1 .191-1.461l11.432 1.5a.736.736 0 0 1-.094 1.467Z",
  fill: "#005b9e"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23973"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 288",
  fill: "#fff",
  d: "m132.133 156.75-3.96 19.08"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23355",
  d: "M128.173 176.57a.736.736 0 0 1-.722-.886l3.96-19.08a.736.736 0 0 1 1.442.3l-3.964 19.076a.736.736 0 0 1-.716.59Z",
  fill: "#005b9e"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23974",
  fill: "#0445a5"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 289",
  d: "M35.783 146.974v-13.597"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23356",
  d: "M35.784 147.711a.737.737 0 0 1-.737-.737v-13.6a.737.737 0 1 1 1.473 0v13.6a.736.736 0 0 1-.736.737Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23975"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 290",
  fill: "#fff",
  d: "M105.454 147.143v-22.886"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23357",
  d: "M105.453 147.879a.737.737 0 0 1-.736-.737v-22.885a.737.737 0 1 1 1.473 0v22.886a.736.736 0 0 1-.737.736Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23976"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23358",
  d: "M152.692 129.958a.724.724 0 0 1-.427-.138.735.735 0 0 1-.171-1.027l5.66-7.923a.737.737 0 0 1 1.2.856l-5.66 7.923a.736.736 0 0 1-.602.309Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23977"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23359",
  d: "M176.747 132.147a.734.734 0 0 1-.147-.014l-22.381-4.528a.737.737 0 0 1 .292-1.445l22.381 4.529a.736.736 0 0 1-.146 1.458Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23978"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23360",
  d: "M177.384 128.014a.793.793 0 0 1-.112-.008l-20.559-3.114a.737.737 0 0 1 .221-1.457l20.557 3.118a.737.737 0 0 1-.109 1.465Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23980"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23362",
  d: "M83.453 62.938a.737.737 0 0 1-.467-1.306l2.231-1.827-2.456-1.3a.736.736 0 1 1 .689-1.3l3.436 1.819a.736.736 0 0 1 .122 1.22l-3.088 2.528a.733.733 0 0 1-.467.166Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23981"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23363",
  d: "M35.784 145.596v53.49a.1.1 0 0 1-.1.1H16.366a3.846 3.846 0 0 1-3.846-3.846v-49.744a.1.1 0 0 1 .1-.1",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23364",
  d: "M35.68 199.925H16.366a4.587 4.587 0 0 1-4.582-4.583v-49.746a.84.84 0 0 1 .839-.839.737.737 0 0 1 .634 1.112v49.473a3.113 3.113 0 0 0 3.109 3.11h18.681v-52.856a.737.737 0 0 1 1.473 0v53.49a.84.84 0 0 1-.84.839Z",
  fill: "#0445a5"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23983"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23365",
  d: "M94.192 15.078H58.011a.442.442 0 0 1 0-.884h36.181a.442.442 0 0 1 0 .884Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23984",
  transform: "translate(44.694 12.295)",
  fill: "#0f5aec"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1799",
  cx: 1.898,
  cy: 1.898,
  r: 1.898,
  transform: "translate(.442 .442)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23366",
  d: "M2.34 4.681a2.341 2.341 0 1 1 2.341-2.34 2.343 2.343 0 0 1-2.341 2.34Zm0-3.8a1.457 1.457 0 1 0 1.457 1.457A1.459 1.459 0 0 0 2.34.884Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23985",
  transform: "translate(63.806 134.219)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 6710",
  width: 12.52,
  height: 17.8,
  rx: 3.47,
  transform: "rotate(180 6.628 9.268)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23367",
  d: "M11.212 19.274H2.781A2.784 2.784 0 0 1 0 16.493V2.781A2.784 2.784 0 0 1 2.781 0h8.431a2.784 2.784 0 0 1 2.781 2.781v13.712a2.784 2.784 0 0 1-2.781 2.781Zm-8.431-17.8a1.31 1.31 0 0 0-1.308 1.308v13.712a1.31 1.31 0 0 0 1.308 1.308h8.431a1.31 1.31 0 0 0 1.308-1.308V2.781a1.31 1.31 0 0 0-1.308-1.308Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23986"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23368",
  d: "M70.803 137.125a.737.737 0 0 1-.719-.6l-5.585-29.866a.736.736 0 1 1 1.448-.27l4.886 26.127 4.767-23.828a.737.737 0 0 1 1.445.289l-5.52 27.557a.736.736 0 0 1-.722.591Z",
  fill: "#232649"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23987"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23369",
  d: "M60.545 110.394a3.24 3.24 0 0 1-.866-.116c-1.554-.428-2.6-1.866-3.209-4.393a37.3 37.3 0 0 1-.755-13.162.745.745 0 0 1 .82-.643.737.737 0 0 1 .643.82 35.809 35.809 0 0 0 .725 12.64c.463 1.932 1.193 3.048 2.169 3.317a3.294 3.294 0 0 0 2.726-.955c.372-.324.714-.684 1.076-1.066a12.78 12.78 0 0 1 1.67-1.558 7.437 7.437 0 0 1 8.2 0 12.788 12.788 0 0 1 1.671 1.558c.362.382.7.742 1.076 1.066a3.289 3.289 0 0 0 2.726.955c.975-.269 1.705-1.385 2.168-3.317a35.618 35.618 0 0 0 .725-12.64.737.737 0 1 1 1.463-.177 37.111 37.111 0 0 1-.755 13.162c-.607 2.527-1.656 3.965-3.209 4.393a4.529 4.529 0 0 1-4.086-1.264 17.007 17.007 0 0 1-1.176-1.162 11.613 11.613 0 0 0-1.475-1.386 5.12 5.12 0 0 0-3.024-.947.776.776 0 0 1-.1.006h-.208a.776.776 0 0 1-.1-.006 5.124 5.124 0 0 0-3.025.947 11.493 11.493 0 0 0-1.474 1.386c-.37.389-.753.792-1.177 1.162a5.033 5.033 0 0 1-3.219 1.38Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23988"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23370",
  d: "m141.004 26.186-18.289 54.751c-1.944 5.82 2.4 10.44 9.659 10.442l36.146.012.031 22.321 11.024-22.318h2.1c7.233 0 15.355-4.6 18.2-10.407l26.8-54.594c3.607-7.347-.205-13.469-8.606-13.494l-57.288-.164c-8.428-.022-17.316 6.08-19.777 13.451Z",
  fill: "#232649"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23989",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23371",
  d: "M175.676 25.692 164.09 56.611h9.817l16.186-30.919Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23372",
  d: "M173.907 57.054h-9.817a.442.442 0 0 1-.414-.6l11.587-30.921a.442.442 0 0 1 .414-.287h14.417a.441.441 0 0 1 .391.646l-16.186 30.92a.441.441 0 0 1-.392.242Zm-9.18-.884h8.912l15.724-30.037h-13.38Z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23990",
  transform: "translate(160.199 62.156)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1800",
  cx: 5.564,
  cy: 5.564,
  r: 5.564,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23991"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23373",
  d: "m225.693 201.458-36.159 20.907-26.328-45.537 27.282-15.77 13.245 2.512Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23374",
  d: "M189.534 223.099a.735.735 0 0 1-.638-.368l-26.332-45.535a.736.736 0 0 1 .269-1.006l27.282-15.775a.735.735 0 0 1 .506-.086l13.245 2.512a.736.736 0 0 1 .5.355l21.96 37.89a.736.736 0 0 1-.268 1.007l-36.159 20.908a.739.739 0 0 1-.365.098Zm-25.322-46 25.591 44.26 34.883-20.17-21.422-36.964-12.645-2.4Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23992"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 291",
  fill: "#fff",
  d: "m175.145 184.104 21.488-12.424"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23375",
  d: "M175.146 184.546a.442.442 0 0 1-.222-.824l21.488-12.424a.442.442 0 1 1 .442.765l-21.488 12.424a.44.44 0 0 1-.22.059Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23993"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 292",
  fill: "#fff",
  d: "m177.906 188.879 24.554-14.197"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23376",
  d: "M177.91 189.322a.442.442 0 0 1-.222-.825l24.554-14.2a.442.442 0 1 1 .442.765l-24.554 14.2a.441.441 0 0 1-.22.06Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23994"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 293",
  fill: "#fff",
  d: "m180.666 193.653 24.539-14.188"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23377",
  d: "M180.667 194.095a.442.442 0 0 1-.221-.824l24.538-14.188a.442.442 0 1 1 .442.765l-24.54 14.188a.44.44 0 0 1-.219.059Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23995"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 294",
  fill: "#fff",
  d: "m183.396 198.445 24.539-14.188"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23378",
  d: "M183.397 198.887a.442.442 0 0 1-.222-.824l24.539-14.188a.442.442 0 1 1 .442.765l-24.538 14.188a.434.434 0 0 1-.221.059Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23996"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 295",
  fill: "#fff",
  d: "m186.172 203.211 24.539-14.188"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23379",
  d: "M186.173 203.654a.442.442 0 0 1-.222-.825l24.539-14.188a.442.442 0 1 1 .442.765l-24.538 14.188a.436.436 0 0 1-.221.06Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23997"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 296",
  fill: "#fff",
  d: "m188.902 208.002 24.539-14.188"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23380",
  d: "M188.903 208.445a.442.442 0 0 1-.222-.825l24.539-14.188a.442.442 0 0 1 .442.765l-24.539 14.188a.441.441 0 0 1-.22.06Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23998"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 297",
  fill: "#fff",
  d: "m191.724 212.741 24.539-14.188"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23381",
  d: "M191.725 213.184a.442.442 0 0 1-.221-.825l24.539-14.188a.442.442 0 0 1 .442.765l-24.54 14.185a.441.441 0 0 1-.22.063Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23999"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23382",
  d: "M194.895 169.411a.756.756 0 0 1-.191-.025.739.739 0 0 1-.447-.343l-4.407-7.623a.737.737 0 1 1 1.275-.738l4.038 6.985 8.2-4.741a.737.737 0 0 1 .738 1.275l-8.838 5.11a.737.737 0 0 1-.368.1Z",
  fill: "#0445a5"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24000",
  transform: "translate(208.929 114.077)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 6711",
  width: 53.198,
  height: 34.896,
  rx: 3.156,
  transform: "rotate(17.394 4.483 35.104)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23383",
  d: "M49.816 49.735a2.609 2.609 0 0 1-.78-.12L1.82 34.824a2.594 2.594 0 0 1-1.7-3.253L9.44 1.818a2.6 2.6 0 0 1 3.253-1.7L59.909 14.91a2.6 2.6 0 0 1 1.7 3.253l-9.321 29.752a2.6 2.6 0 0 1-2.473 1.821Zm-37.9-48.263a1.126 1.126 0 0 0-1.073.787l-9.32 29.753a1.122 1.122 0 0 0 .737 1.407L49.475 48.21a1.123 1.123 0 0 0 1.407-.736l9.321-29.752a1.123 1.123 0 0 0-.736-1.407L12.251 1.523a1.139 1.139 0 0 0-.333-.051Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24003"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24001"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 298",
  fill: "#fff",
  d: "m210.728 146.065 18.844-11.112"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23384",
  d: "M210.729 146.506a.442.442 0 0 1-.224-.823l18.844-11.111a.442.442 0 0 1 .449.762l-18.844 11.111a.443.443 0 0 1-.225.061Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24002"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 299",
  fill: "#fff",
  d: "m259.549 161.551-9.217-20.053"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23385",
  d: "M259.55 161.997a.443.443 0 0 1-.4-.257l-9.217-20.053a.442.442 0 0 1 .8-.369l9.217 20.053a.442.442 0 0 1-.217.586.436.436 0 0 1-.183.04Z",
  fill: "#0f5aec"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24004"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23386",
  d: "m217.928 119.768 18.026 22.83a4.815 4.815 0 0 0 4.909 1.538l27.83-8.465",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23387",
  d: "M239.659 144.747a5.276 5.276 0 0 1-4.052-1.878l-18.026-22.83a.442.442 0 1 1 .694-.548l18.026 22.83a4.376 4.376 0 0 0 4.434 1.389l27.829-8.465a.442.442 0 0 1 .256.846l-27.829 8.465a4.6 4.6 0 0 1-1.332.191Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24005"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23388",
  d: "m225.908 73.727 20.632 2.306-4.792 4.777 11.135 4.877-2.946 5.585-10.213-6.776-1.805 6.761Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23389",
  d: "M249.937 91.857a.586.586 0 0 1-.323-.1l-9.535-6.327-1.595 5.975a.585.585 0 0 1-1.047.179l-12.011-17.531a.584.584 0 0 1 .547-.911l20.632 2.306a.585.585 0 0 1 .348.995l-4.186 4.172 10.35 4.534a.584.584 0 0 1 .282.807l-2.947 5.585a.583.583 0 0 1-.373.294.559.559 0 0 1-.142.022Zm-10.212-7.945a.588.588 0 0 1 .323.1l9.674 6.42 2.352-4.458-10.56-4.626a.584.584 0 0 1-.178-.949l3.931-3.916-18.155-2.029 10.571 15.43 1.477-5.533a.584.584 0 0 1 .565-.434Z",
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24006",
  transform: "translate(242.73 103.376)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1801",
  cx: 5.168,
  cy: 5.168,
  r: 5.168,
  fill: "#ffd627"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24007",
  transform: "translate(220.157 54.86)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1802",
  cx: 5.168,
  cy: 5.168,
  r: 5.168,
  fill: "#0f5aec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24008",
  transform: "translate(225.325 166.512)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1803",
  cx: 5.168,
  cy: 5.168,
  r: 5.168,
  fill: "#e84c4c"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24009",
  transform: "translate(153.188 198.491)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1804",
  cx: 5.168,
  cy: 5.168,
  r: 5.168,
  fill: "#0f5aec"
})))));
export default SvgPhoneImage;